module.exports = __webpack_public_path__ + "img/sesumeter-m.643f70cc.png";